module.exports = __webpack_public_path__ + "static/media/iconLocation.bb0f1daa.svg";